import { CSSProperties } from 'react';
import {
  ACCENT_BUTTON,
  COLORS,
  CONTENT_COLUMN,
  DISPLAY_STRETCH,
  FONTS,
  META,
} from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  section: {
    ...CONTENT_COLUMN,
    minHeight: '76vh',
    padding: '5.5rem 6vw 4rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  copy: {
    maxWidth: '40rem',
  },
  eyebrow: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.label,
    marginBottom: '1.5rem',
  },
  headline: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: 'clamp(2.8rem, 7vw, 5.25rem)',
    lineHeight: 0.98,
    letterSpacing: '-0.01em',
    color: COLORS.text,
  },
  subline: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: 'clamp(1.4rem, 2.6vw, 1.95rem)',
    lineHeight: 1.2,
    color: COLORS.muted,
    marginTop: '1.25rem',
  },
  shared: {
    color: COLORS.signal,
  },
  body: {
    fontSize: '1.0625rem',
    lineHeight: 1.7,
    color: COLORS.muted,
    maxWidth: '34rem',
    marginTop: '1.5rem',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '1rem 1.5rem',
    marginTop: '2.25rem',
  },
  cta: {
    ...ACCENT_BUTTON,
    fontFamily: FONTS.body,
    fontWeight: 600,
    fontSize: '1rem',
    padding: '0.95rem 1.75rem',
    textDecoration: 'none',
  },
  ctaNote: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.label,
  },
};
